import { cn } from "@/lib/cn";
import type { TableToolbarProps } from "./DataTable.types";

export function TableToolbar({ title, description, totalLabel, loadingLabel, search, actions, columnVisibility, className }: TableToolbarProps) {
  return (
    <div className={cn("bfrs-flex bfrs-flex-wrap bfrs-items-center bfrs-gap-3 bfrs-border-b bfrs-border-border bfrs-bg-surface-card bfrs-px-5 bfrs-py-2", className)}>
      {(title || description || totalLabel) && (
        <div className="bfrs-min-w-0">
          {title && <div className="bfrs-truncate bfrs-text-sm bfrs-font-bold bfrs-text-text-primary">{title}</div>}
          {description && <div className="bfrs-truncate bfrs-text-xs bfrs-text-text-muted">{description}</div>}
          {totalLabel && <div className="bfrs-text-xs bfrs-text-text-muted">{totalLabel}</div>}
        </div>
      )}
      {search}
      <div className="bfrs-min-w-2 bfrs-flex-1" />
      {loadingLabel && <span className="bfrs-text-xs bfrs-text-text-muted">{loadingLabel}</span>}
      {columnVisibility}
      {actions}
    </div>
  );
}
